<template>
  <div class="position-relative">
    <div
      class="dropdown position-absolute"
      v-if="
        (reply.ownable.id === loggedInAs.id && !reply.by_admin) || loggedInAs.type === 'App\\User'
      "
      style="top:0; right:0;"
    >
      <button
        class="btn btn-link btn-sm"
        type="button"
        id="dropdownMenuButton"
        data-bs-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
      >
        <i class="fas fa-ellipsis-h"></i>
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item" href="#" @click.prevent="remove">
          {{ 'Delete' | translate }}
        </a>
      </div>
    </div>
    <div class="row">
      <div class="col-auto">
        <Avatar :user="student" size="30"></Avatar>
      </div>
      <div class="col">
        <div>
          <router-link
            class="fw-bold text-dark"
            :to="{
              name: 'students.show',
              params: { student: reply.ownable.id },
            }"
            v-if="loggedInAs.type === 'App\\User' && !reply.by_admin"
          >
            {{ author }}
          </router-link>

          <span v-else class="fw-bold">{{ author }}</span>
          <i v-if="reply.by_admin" class="fas fa-shield-alt"></i>
          <small class="text-muted">{{ time(reply.created_at) }}</small>
        </div>
        <div class="mb-0" style="white-space: pre-wrap;">{{ reply.body }}</div>
        <div v-if="reply.image">
          <img :src="imageUrl(reply.image)" alt="" class="img-fluid mt-2">
        </div>
        <div>
          <div class="d-flex mb-3">
            <Votes :votable="reply"></Votes>
            <div>
              <small class="me-2">
                <a
                  class="text-uppercase text-dark"
                  href="#"
                  @click.prevent="toggleReplyCreate"
                >
                  {{ 'Reply' | translate }}
                </a>
              </small>
            </div>
          </div>
          <ReplyCreate
            :comment="comment"
            :reply="reply"
            :show="replyCreate"
            @toggleReplyCreate="toggleReplyCreate"
            @replyCreated="replyCreated"
          ></ReplyCreate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from '~/player/components/Avatar'
import Votes from '~/player/components/Votes'
import ReplyCreate from '~/player/components/ReplyCreate'
import dayjs from 'dayjs'

export default {
  props: ['comment', 'reply'],
  components: {
    Avatar,
    Votes,
    ReplyCreate,
  },
  data() {
    return {
      replyCreate: false,
    }
  },

  methods: {
    imageUrl(url = false) {
        if (!url) {
            return false
        }
        return `https://djceg34j53tq.cloudfront.net/${url}`
    },
    replyCreated(data) {
      this.$emit('replyCreated', data)
    },
    toggleReplyCreate() {
      this.replyCreate = !this.replyCreate
    },
    time(date) {
      return dayjs(date).fromNow()
    },
    remove() {
      let confirmed = confirm(this.$t('Are you sure?'))
      if (!confirmed) {
        return false
      }

      return this.$api.replies.delete(this.reply.id).then(() => {
        this.$emit('replyRemoved', this.reply.id)
      })
    },
  },
  computed: {
    loggedInAs() {
      return this.$store.state.user
    },
    student() {
      return this.reply.ownable
    },
    author() {
      return this.reply.ownable.name
    },
  },
}
</script>

<style></style>
